import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, IonSearchbar, PopoverController } from '@ionic/angular';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AbstractModalWithResult } from 'src/app/shared/components/abstract-modal-with-result';
import { StringSearchService } from 'src/app/shared/services/string-search.service';

import { AssigneeList } from '../../shared/models';

@Component({
  selector: 'app-assignee-list',
  templateUrl: './assignee-list-popover.component.html',
  styleUrls: ['./assignee-list-popover.component.scss'],
})
export class AssigneeListPopoverComponent extends AbstractModalWithResult<number> implements OnInit, AfterViewInit {
  @Input() assigneeList: AssigneeList;
  @ViewChild(IonContent) ionContent: IonContent;
  @ViewChild(IonSearchbar) ionSearchbar: IonSearchbar;

  static modalId = 'AssigneeListPopoverComponent';

  displayedAssigneeList: AssigneeList;
  showSearchField = false;

  constructor(
    private alcmeonContext: AlcmeonContextService,
    popoverController: PopoverController,
    private stringSearchService: StringSearchService
  ) {
    super(popoverController);
  }

  ngOnInit(): void {
    this.displayedAssigneeList = this.assigneeList;
    this.showSearchField = this.assigneeList.common_users.length + this.assigneeList.company_users.length > 2;
  }

  ngAfterViewInit() {
    // Wait until the popover animation has completed to set the focus
    setTimeout(() => {
      this.ionSearchbar?.setFocus();
    }, 500);
  }

  getModalId() {
    return AssigneeListPopoverComponent.modalId;
  }

  onSearchTermChange(event: Event) {
    const term = this.normalizeText((event.target as HTMLInputElement).value);

    const common_users = this.assigneeList.common_users.filter(user => {
      return this.normalizeText(user.realname).includes(term);
    });

    const company_users = this.assigneeList.company_users.filter(user => {
      return this.normalizeText(user.realname).includes(term);
    });

    this.displayedAssigneeList = { common_users, company_users };
    this.scrollToTop();
  }

  onEnterPressed() {
    if (this.displayedAssigneeList.common_users.length === 1 && this.displayedAssigneeList.company_users.length === 0) {
      this.ok(this.displayedAssigneeList.common_users[0].id);
    }

    if (this.displayedAssigneeList.common_users.length === 0 && this.displayedAssigneeList.company_users.length === 1) {
      this.ok(this.displayedAssigneeList.company_users[0].id);
    }
  }

  private scrollToTop() {
    if (this.ionContent) {
      this.ionContent.scrollToTop(0);
    }
  }

  private normalizeText(text: string): string {
    return this.stringSearchService.removeDiacriticsThenLowerCase(text, this.alcmeonContext.lang);
  }
}
